import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat, get } from 'lodash';
import React, { FC, useMemo } from 'react';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getProjektLaufzeitBIS_Validation,
	getProjektLaufzeitVON_Validation,
} from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { ANTRAGS_FORMULAREN, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import { formStrucProjektdatenPruefassistentGlobal } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
let P = Schema.attributes;

const ProjektDatenSkizzeEmob: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const isVorhabensartFieldDisabled = useMemo(() => {
		if (updatedReadOnly) return true;
		if (get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.EmobInvest) {
			return true;
		}
		if (get(application, P.Verbundpartner.path, []).length > 0) {
			return true;
		}
		return false;
	}, [application, updatedReadOnly]);

	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Allgemein_Pruefung_Pruefstatus.path}
				hinweisPath={P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Allgemein_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Allgemein_Pruefung_Erledigt.path}
				formStruc={formStrucProjektdatenPruefassistentGlobal(application)}
			/>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStruc(isVorhabensartFieldDisabled)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStruc2(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default ProjektDatenSkizzeEmob;

const formStruc = (isVorhabensartFieldDisabled?: boolean) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Allgemein_Projekttitel,
				{ ...P.Allgemein_Kurzwort, maxCharLength: 12 },
				{
					...P.Allgemein_Vorhabensart,
					disabled: isVorhabensartFieldDisabled,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStruc2 = (application: any): FormStrucItem[] => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Allgemein_Geplante_Projektlaufzeit_von,
					...getProjektLaufzeitVON_Validation(application),
				},
				{
					...P.Allgemein_Geplante_Projektlaufzeit_bis,
					...getProjektLaufzeitBIS_Validation(application),
				},
			],
		},
		{
			fields: [],
			userProps: { columnToDivide: 1 },
		},
		get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.EmobFundE ?
			{
				fields: [{ ...P.Allgemein_Projektstart_Jahr, disabled: true }, P.Allgemein_Durchfuehrungsort, P.Allgemein_Forschungscharakter],
				userProps: { direction: 'column', columnToDivide: 1 },
			}
		:	{
				fields: [{ ...P.Allgemein_Projektstart_Jahr, disabled: true }, P.Allgemein_Durchfuehrungsort, P.Allgemein_Finanzierungsart],
				userProps: { direction: 'column', columnToDivide: 1 },
			},
	];
	return struc;
};

export const getFormStrucProjektDatenSkizzeEmob = (application: any, _readOnly: boolean) => {
	let result: FormStrucItem[] = [];
	result = concat(formStruc(), formStruc2(application));

	if (
		checkIfPruefAssitenzNeedsToValidate(application, P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path, P.Allgemein_Pruefung_Erledigt.path)
	) {
		result = concat(formStrucProjektdatenPruefassistentGlobal(application), result);
	}
	return result;
};
